@if ((tableModel$ | async); as tableModel) {
  <p-table [scTableSettings]="tableModel.tableSettings">
    <!-- <ng-template pTemplate="tools-panel-left">
    <p-button *ngIf="!tableModel.hasChapters && !tableModel.isReadonly"
      (onClick)="openProjectThemasDialog()"
      label="Update Themas"
      i18n-label>
    </p-button>
  </ng-template> -->
    @if (tableModel.hasChapters && !tableModel.isReadonly; as rowData) {
      <ng-template pTemplate="row-actions"
                   let-rowData>
        <p-button styleClass="p-button-rounded p-button-text"
                  icon="fas fa-pen"
                  (onClick)="openChapterThemasDialog(rowData)"
                  pTooltip="Click to update themas"
                  tooltipPosition="top"
                  i18n-pTooltip>
        </p-button>
      </ng-template>
    }
  </p-table>
}